import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import { useTable } from 'hooks'
import { documents } from 'orm'
import { getColumns } from './model'

const useDocumentsTableMutations = () => {
  const dispatch = useDispatch()

  const handleFetchDocuments = React.useCallback(
    ({ limit, offset, ordering, search }) => {
      dispatch(documents.fetchStart({ limit, offset, ordering, search }))
    },
    [dispatch],
  )

  return {
    handleFetchDocuments,
  }
}

const useDocumentsTableData = () => {
  const data = useSelector(documents.getModel)

  const { count, items = [], order = [] } = data ?? {}

  return {
    state: { count, items, order },
  }
}

export const useDocumentsTable = state => {
  const { mapSortingPropToQueryParam, search } = state

  const columns = getColumns()

  const dispatch = useDispatch()

  const { handleFetchDocuments } = useDocumentsTableMutations()

  const {
    state: { count, items, order },
  } = useDocumentsTableData()

  const handleRefetch = React.useCallback(
    ({ limit, offset, ordering, search }) => {
      handleFetchDocuments({ limit, offset, ordering, search })
    },
    [handleFetchDocuments],
  )

  const handleQueriesUpdate = React.useCallback(
    ({ limit, offset, ordering, search }) => {
      dispatch(
        documents.toDetail(null, null, { limit, offset, ordering, search }),
      )
    },
    [dispatch],
  )

  const {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  } = useTable({
    columns,
    data: R.props(order, items),
    mapSortingPropToQueryParam,
    pageCount: count,
    search,
    fetchAction: handleRefetch,
    updateQueriesAction: handleQueriesUpdate,
  })

  return {
    state: {
      pagination: { currentPage, pageCount, perPage },
      table: { headers, model, isFetching },
    },
    handlers: {
      pagination: { handlePage, handlePageSize },
    },
  }
}
